export default {
  subscription: ({ current }, getters, { entities }) => entities.subscriptions.byId[current],
  subscriptions: ({ ids }, getters, { entities }) =>
    ids.map((id) => entities.subscriptions.byId[id]),
};
